var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from '~/core/decorator';
import { FilterService } from '~/utils/filter.service';
var CaseAssistAntiFraudCaseStayService = /** @class */ (function () {
    function CaseAssistAntiFraudCaseStayService() {
    }
    /**
     * 协催管理-反欺诈待分配
     */
    CaseAssistAntiFraudCaseStayService.prototype.queryAntiFraudList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseAssistAntiFraudCaseStayCase.queryAntiFraudList,
            data: {
                caseNumber: data.caseNumber,
                personalName: data.personalName,
                mobileNo: data.mobileNo,
                idCard: data.idCard,
                areaId: data.areaId,
                customerCategory: data.customerCategory,
                overduePeriod: data.overduePeriod,
                addressDetail: data.addressDetail,
                overdueAmountMin: data.overdueAmount ? data.overdueAmount.min : '',
                overdueAmountMax: data.overdueAmount ? data.overdueAmount.max : '',
                overdueDaysMax: data.overdueDays ? data.overdueDays.max : '',
                overdueDaysMin: data.overdueDays ? data.overdueDays.min : '',
                turnSource: data.turnSource,
                productCategory: data.productCategory,
                createTimeStart: FilterService.dateRanageFormat(data.createTime).start,
                createTimeEnd: FilterService.dateRanageFormat(data.createTime).end,
                productName: data.productName,
                labelName: data.labelName
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 协催管理-反欺诈待分配-预览
     */
    CaseAssistAntiFraudCaseStayService.prototype.previewCaseAssist = function (data) {
        return this.netService.send({
            server: domainService.caseAssistAntiFraudCaseStayCase.previewCaseAssist,
            data: data,
        });
    };
    /**
     * 协催管理-反欺诈待分配-确定
     */
    CaseAssistAntiFraudCaseStayService.prototype.confirmDistributeCase = function (data) {
        return this.netService.send({
            server: domainService.caseAssistAntiFraudCaseStayCase.distributeCaseAssist,
            data: data,
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseAssistAntiFraudCaseStayService.prototype, "netService", void 0);
    return CaseAssistAntiFraudCaseStayService;
}());
export { CaseAssistAntiFraudCaseStayService };
